module.exports = __webpack_public_path__ + "static/social-imagen-8fc305b2d895d79b77f11b6bd0d80cb0.png";